var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"base-avatar-wrapper"},[(!_vm.src)?_c('a-avatar',[(_vm.icon)?_c('a-icon',{attrs:{"type":_vm.icon}}):_vm._e(),_vm._v(" "+_vm._s(_vm.imageText)+" ")],1):_c('a-avatar',{attrs:{"src":_vm.src}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }